import { cn } from '@/lib/cn';

export function RocketMark({
  className,
  launching = false,
}: {
  className?: string;
  launching?: boolean;
}) {
  return (
    <svg
      className={cn('rocket-mark', className)}
      viewBox="0 0 64 64"
      aria-hidden="true"
      focusable="false"
    >
      <g transform={launching ? undefined : 'rotate(45 32 32)'}>
        <path
          className="rocket-mark__body"
          d="M32 7c7 7.6 10.5 15.6 10.5 24 0 8.8-4 15.5-10.5 19.8C25.5 46.5 21.5 39.8 21.5 31 21.5 22.6 25 14.6 32 7Z"
        />
        <path
          className="rocket-mark__fins"
          d="m22.7 31.8-9.2 10.5 11.7-2.8Zm18.6 0 9.2 10.5-11.7-2.8Z"
        />
        <path
          className="rocket-mark__flame"
          d="M27.5 47.2 32 59l4.5-11.8A21 21 0 0 1 32 51a21 21 0 0 1-4.5-3.8Z"
        />
        <circle className="rocket-mark__window" cx="32" cy="27.5" r="4.5" />
      </g>
    </svg>
  );
}
